module.exports = __webpack_public_path__ + "static/media/Rubik-Regular.6840830e.ttf";